import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import Seo from "../../components/_UI/seo";
import AboutS1 from "../../components/aboutS1";
import AboutS2 from "../../components/aboutS2";
import AboutS3 from "../../components/aboutS3";
import AboutS4 from "../../components/aboutS4";
import AboutS5 from "../../components/aboutS5";
import AboutS6 from "../../components/aboutS6";
import AboutS7 from "../../components/aboutS7";
import AboutS8 from "../../components/aboutS8";


const AboutPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('О нас')}/>
            <div className={`${Styles.contentWrap}`}>
                <AboutS1/>
                <AboutS2/>
                <AboutS3/>
                <AboutS4/>
                <AboutS5/>
                <AboutS6/>
                <AboutS8/>
                <AboutS7/>
            </div>
        </section>
    );
};

export default AboutPage;
